var Shipment = Backbone.Model.extend({
    idAttribute: '_id',
});
module.exports = Shipment;
